<template>

    <div style="position: relative;height: 100%;" v-loading="loading" element-loading-text="数据拼命加载中...">
        <!-- <div class="mask" v-if="authorize">
        	<div style="margin-top: 150px;margin-left: 600px;opacity: 0.7;">
        		<img src="./watermark.png" style="height: 400px;width: 400px;" />
        		<br/>
        		<h1 style="opacity: 0.7;">暂未授权,请联系相关工作人员</h1>
        	</div>
        </div> -->
        <div class="item_block fx fx-c_center info_row">
            <div class="coverimg">
                <el-image style="width: 150px; height: 90px" :src="lessonSystem.coverImg" :lazy="true"
                    :preview-src-list="[lessonSystem.coverImg]" fit="fill"></el-image>
            </div>

            <div style="width: 180px">{{lessonSystem.name}}</div>

            <div> <el-tag size="mini" effect="dark">{{lessonSystem.typeName}}</el-tag> </div>

            <div style="width: 120px" class="fx-col fx-center">
                <span>课程数量：{{lessonSystem.lessonCount}}</span>
                <span>适合人群：{{lessonSystem.suitCrowd}}</span>
            </div>
            <div class="fx-g1">
                <p>{{lessonSystem.introduction}}</p>
            </div>
            <div style="width: 140px">
                <el-button type="primary" size="medium" @click="editLesson({})">添加课程</el-button>
            </div>

        </div>
        <!-- class="item_block" -->

        <div v-for="lesson in lessons" :key="lesson.id" :class="['item_block']">
            <div class="fx fx-c_center info_row" style="border-bottom: 1px solid var(--border)">
                <div class="coverimg">
                    <el-image style="width: 150px; height: 90px" :src="lesson.coverImg" :lazy="true"
                        :preview-src-list="[lesson.coverImg]" fit="fill"></el-image>
                </div>

                <div style="width: 380px;">
                    <div class="lesson_name">{{lesson.name}}</div>
                    <div class="fx fx-m_between fx-c_center lesson_resource" style="margin-top: 12px">
                        <span class="fx fx-c_center">视频:
                            <span v-if="lesson.videos.length==0" class="text_info tip"> 未设置</span>
                            <el-link v-else type="primary" @click="setShowResources(lesson.videos)" :underline="false"
                                class="font12"><i class="iconfont icon-shipin"></i>查看</el-link>
                        </span>
                        <span class="fx fx-c_center">教案:
                            <span v-if="lesson.plans.length==0" class="text_info tip"> 未设置</span>
                            <el-link v-else type="primary" @click="setShowResources(lesson.plans)" :underline="false"
                                class="font12"><i class="iconfont icon-word"></i>查看</el-link>
                        </span>
                        <span class="fx fx-c_center">PPT:
                            <span v-if="lesson.ppts.length==0" class="text_info tip"> 未设置</span>
                            <el-link v-else type="primary" @click="setShowResources(lesson.ppts)" :underline="false"
                                class="font12"><i class="iconfont icon-ppt"></i>查看</el-link>
                        </span>
                        <span class="fx fx-c_center">代码:
                            <span v-if="lesson.codes.length==0" class="text_info tip"> 未设置</span>
                            <el-link v-else type="primary" @click="viewCode(lesson.type, lesson.codes[0].id)"
                                :underline="false" class="font12"><i class="iconfont icon-word"></i>查看</el-link>
                        </span>
                    </div>
                    <div style="margin-top: 12px">
                        <tag-group :tags="lesson.tagArray" size="mini" style="justify-content: flex-start"></tag-group>
                    </div>
                </div>

                <div class="fx-g1">{{lesson.introduction}}</div>

                <div style="width: 160px" class="fx fx-m_between fx-c_center">
                    <el-link type="primary" @click="editLesson(lesson)" :underline="false"><i
                            class="iconfont icon-bianji"></i><b>编辑</b></el-link>
                    <el-popconfirm @onConfirm="delLesson(lesson)" title="确认删除该课程吗？">
                        <el-link type="danger" slot="reference" :underline="false"><i
                                class="iconfont icon-shanchu"></i><b>删除</b></el-link>
                    </el-popconfirm>
                </div>

            </div>
            <div class="fx fx-m_between fx-c_center font16"
                style="padding: 15px 0; border-bottom: 1px solid var(--border)">
                <span>课程任务</span>
                <div>
                    <el-link type="primary" :underline="false" @click="editTask({}, lesson.id)"> <i
                            class="el-icon-circle-plus"></i><b> 添加</b> </el-link>
                    <el-link type="primary" :underline="false" @click="openTask(lesson.id)"> <i
                            class="el-icon-circle-plus"></i><b> 选择任务</b> </el-link>
                </div>
                <!-- <template >
                    <span class="pointer fx-c_center" style="display: inline-flex" @click="openTask">
                        <i class="iconfont icon-plus-square-fill font26 " style="margin-right: 5px;color:var(--primary);padding:0;border-radius: 28px;overflow: hidden"></i>
                        <span style="color: #3c3c3c;font-size: 15px;">选择任务</span>
                    </span>
                </template> -->
            </div>

            <div style="padding: 15px 0">
                <div v-for="(task,i) in lesson.tasks" :key="task.id" class="fx fx-c_center info_row task_item"
                    style="margin-bottom: 6px">
                    <div style="width: 200px" v-if="task.linkUseType == 1">任务{{i+1}}：{{task.title}}</div>

                    <!-- <div style="width: 1000px" v-if="task.linkUseType == 2">题目{{i+1}}：{{task.question.questionFormHtml1}}</div> -->

                    <!-- <div style="width: 1000px" v-if="task.linkUseType == 2">题目{{i+1}}：
                    <span v-if="task.question">
                        {{task.question.questionFormHtml1}}
                    </span>


                    </div> -->

                    <div style="width: 1000px" v-if="task.linkUseType == 2">题目{{i+1}}：{{task.title}}</div>


                    <!-- <div style="width: 200px" v-if="task.linkUseType == 3">
                        模块{{i+1}}：{{task.module.title}}
                    </div> -->
                   <!-- <div class="fx-g1 task fx fx-m_start fx-c_center task_info" v-if="task.linkUseType == 3">
                        <span class="fx fx-c_center">题目总数：{{task.module.questionCount}}</span>
                    </div> -->

                    <div style="width: 200px" v-if="task.linkUseType == 3">
                         模块{{i+1}}：{{task.title}}
                     </div>
                   <!-- <div class="fx-g1 task fx fx-m_start fx-c_center task_info" v-if="task.linkUseType == 3">
                         <span class="fx fx-c_center">题目总数：{{task.questionCount}}</span>
                     </div> -->

                    <div class="fx-g1 task fx fx-m_start fx-c_center task_info" v-if="task.linkUseType == 1">
                        <span class="fx fx-c_center">讲解视频:
                            <span v-if="task.videos.length==0" class="text_info tip"> 未设置</span>
                            <el-link v-else @click="setShowResources(task.videos)" type="warning" :underline="false"
                                class="font12"><i class="iconfont icon-shipin"></i>查看</el-link>
                        </span>
                        <span class="fx fx-c_center">随堂资料:
                            <span v-if="task.attachments.length==0" class="text_info tip"> 未设置</span>
                            <el-link v-else @click="setShowResources(task.attachments)" type="warning"
                                :underline="false" class="font12"><i class="iconfont icon-word"></i>查看</el-link>
                        </span>
                        <span class="fx fx-c_center">任务卡片:
                            <span v-if="task.tutorials.length==0" class="text_info tip"> 未设置</span>
                            <el-link v-else @click="setShowResources(task.tutorials)" type="warning" :underline="false"
                                class="font12"><i class="iconfont icon-ppt"></i>查看</el-link>
                        </span>
                        <span class="fx fx-c_center">相关代码:
                            <span v-if="task.codes.length==0" class="text_info tip"> 未设置</span>
                            <el-link v-else @click="viewCode(lesson.type, task.codes[0].id)" type="warning"
                                :underline="false" class="font12"><i class="iconfont icon-word"></i>查看</el-link>
                        </span>
                    </div>
                    <div class="fx-g1 task fx fx-m_start fx-c_center task_info" v-if="task.linkUseType != 1">
                    </div>
                    <div style="">
                        <el-link type="primary" @click="editTask(task, lesson.id)" v-if="task.linkUseType == 1"
                            :underline="false"><i class="iconfont icon-bianji"></i><b>编辑</b></el-link>
                        <el-popconfirm @onConfirm="delTask(task, lesson)" title="确认删除该任务吗？">
                            <el-link type="danger" slot="reference" :underline="false"><i
                                    class="iconfont icon-shanchu"></i><b>删除</b></el-link>
                        </el-popconfirm>
                    </div>
                </div>
            </div>

            <template>
                <el-dialog title="选择添加的任务" :visible.sync="dialogTableVisible" center width="60%"
                    style="margin-top: -11vh;" class="task_dialog">
                    <div style="margin-bottom: 10px;">
                        <!--                        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                            <el-tab-pane label="任务" name="task"></el-tab-pane>
                            <el-tab-pane label="题目" name="question"></el-tab-pane>
                            <el-tab-pane label="题库" name="train"></el-tab-pane>
                        </el-tabs>-->
                        <el-radio-group v-model="activeName">
                            <el-radio-button label="task">任务</el-radio-button>
                            <el-radio-button label="question">题目</el-radio-button>
                            <el-radio-button label="train">模块</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div v-if="activeName == 'task'" key='a1'>
                        <div class="">
                            <el-form :inline="true" :model="taskForm">
                                <div class="block">
                                    <el-select v-model="taskForm.checkType" placeholder="选项" @change="changeOptions">
                                        <el-option label="平台" :value="true"></el-option>
                                        <el-option label="学校" :value="false"></el-option>
                                    </el-select>
                                    <el-cascader placeholder="任务知识点筛选" v-model="taskForm.knowledgeIds"
                                        :options="options" :props="{expandTrigger: 'hover'}" @change="handleChange"
                                        style="width: 300px;margin-left: 20px;" clearable>

                                    </el-cascader>
                                    <el-form-item label="" style="margin-left: 20px">
                                        <el-input v-model="taskForm.keywords" placeholder="请输入任务关键词"
                                            class="keyword_input" style="width: 300px;">
                                            <i slot="suffix"
                                                class="el-input__icon el-icon-search font22 text_primary"></i>
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </el-form>
                        </div>

                        <el-table :data="taskData" style="height:500px;overflow-y:visible"
                            @selection-change="handleChoose" ref="libTable">
                            <el-table-column type="selection" width="55">
                            </el-table-column>
                            <el-table-column property="date" label="任务" min-width="150">
                                <template slot-scope="scope">
                                    {{scope.row.title}}
                                </template>
                            </el-table-column>
                            <el-table-column property="date" label="知识点" min-width="250">
                                <template slot-scope="scope">
                                    <tag-group :tags="scope.row.knowledgeArray" size="medium"></tag-group>
                                </template>
                            </el-table-column>

                            <el-table-column width="500" label="资料">
                                <template slot-scope="scope">
                                    <div class="grid col-4 hgap-5">
                                        <div class="fx fx-c_center" v-if="scope.row.videos.length > 0">
                                            讲解视频：
                                            <el-button type="text" @click="setShowResources(scope.row.videos)"
                                                size="medium" class="text_warn">查看</el-button>
                                        </div>
                                        <div class="fx fx-c_center" v-if="scope.row.attachments.length > 0">
                                            随堂资料：
                                            <el-button type="text" @click="setShowResources(scope.row.attachments)"
                                                size="medium" class="text_warn">查看</el-button>
                                        </div>
                                        <div class="fx fx-c_center" v-if="scope.row.codes.length > 0">
                                            代码：
                                            <el-button type="text" @click="viewCodeDialog(scope.row.codes[0].id)"
                                                size="medium" class="text_warn">查看</el-button>
                                        </div>
                                        <div class="fx fx-c_center" v-if="scope.row.tutorials.length > 0">
                                            卡片：
                                            <el-button type="text" @click="setShowResources(scope.row.tutorials)"
                                                size="medium" class="text_warn">查看</el-button>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-if="activeName=='question'" key='b1'>
                        <div class="">
                            <el-form :inline="true" :model="form1">
                                <div class="block">
                                    <!--<el-form-item label="选项">
                                            <el-select v-model="checkType" placeholder="选项" @change="changeOptions">
                                                <el-option label="平台" :value="true"></el-option>
                                                <el-option label="学校" :value="false"></el-option>
                                            </el-select>
                                        </el-form-item>-->
                                    <el-form-item label="关键词">
                                        <el-input v-model="form1.keywords" placeholder="关键词"></el-input>
                                    </el-form-item>
                                    <el-form-item label="类型">
                                        <el-select v-model="form1.type" placeholder="类型" clearable>
                                            <el-option v-for="item in types" :key="item.optionValue"
                                                :label="item.optionText" :value="item.optionValue">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="分类">
                                        <el-select v-model="form1.categoryId" clearable placeholder="分类">
                                            <el-option v-for="item in trainCategorys" :key="item.id" :label="item.name"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="编程语言">
                                        <el-select v-model="form1.optType" clearable placeholder="全部"
                                            style="width: 120px">
                                            <el-option v-for="item in lessonTypes" :key="item.optionValue"
                                                :label="item.optionText" :value="item.optionValue">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </el-form>
                        </div>
                        <el-table :data="questionData" stripe style=" height:500px;overflow-y:visible"
                            @selection-change="handleChoose" ref="libTable">
                            <el-table-column type="selection" width="55">
                            </el-table-column>
                            <el-table-column min-width="180" prop="questionFormHtml" label="题目">
                            </el-table-column>
                            <el-table-column min-width="120" prop="categoryName" label="分类">
                            </el-table-column>
                            <el-table-column min-width="120" label="标签">
                                <template slot-scope="scope">
                                    <tag-group :tags="scope.row.tagNames"></tag-group>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="120" prop="typeName" label="类型">
                            </el-table-column>
                            <el-table-column min-width="120" prop="optName" label="语言类型">
                            </el-table-column>
                            <el-table-column property="date" label="知识点" min-width="250">
                                <template slot-scope="scope">
                                    <tag-group :tags="scope.row.knowledgeArray" size="medium"></tag-group>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="120" prop="score" label="题目分数">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-if="activeName=='train'" key='c1'>
                        <div class="">
                            <el-form :inline="true" :model="form2">
                                <div class="block">
                                    <!--<el-form-item label="选项">
                                            <el-select v-model="checkType" placeholder="选项" @change="changeOptions">
                                                <el-option label="平台" :value="true"></el-option>
                                                <el-option label="学校" :value="false"></el-option>
                                            </el-select>
                                        </el-form-item>-->
                                    <el-form-item label="关键词">
                                        <el-input v-model="form2.keywords" placeholder="关键词"></el-input>
                                    </el-form-item>
                                </div>
                            </el-form>
                        </div>
                        <el-table :data="trainData" stripe style="height:500px;overflow-y:visible"
                            @selection-change="handleChoose" ref="libTable">
                            <el-table-column type="selection" width="55">
                            </el-table-column>
                            <el-table-column min-width="180" prop="title" label="题目">
                            </el-table-column>
                            <el-table-column width="160" label="封面">
                                <template slot-scope="scope">
                                    <el-image style="width: 150px; height: 90px" :src="scope.row.imgPath" :lazy="true"
                                        :preview-src="scope.row.imgPath" fit="fill"></el-image>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="120" prop="typeName" label="类型">
                            </el-table-column>
                            <el-table-column min-width="120" prop="optName" label="语言类型">
                            </el-table-column>
                            <el-table-column min-width="120" prop="categoryName" label="分类">
                            </el-table-column>
                            <el-table-column min-width="120" label="标签">
                                <template slot-scope="scope">
                                    <tag-group :tags="scope.row.tagNames"></tag-group>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="100" prop="questionCount" label="题目总数">
                            </el-table-column>
                            <el-table-column min-width="100" prop="difficulty" label="难度">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="panel_foot fx fx-m_end fx-c_center">
                        <el-pagination :background="true" prev-text="上一页" next-text="下一页" layout="prev, pager, next"
                            :current-page="pager.currentPage" :page-size="pager.pageSize" :total="pager.dataTotal"
                            @current-change="pageChange">
                        </el-pagination>
                    </div>
                    <span slot="footer" class="dialog-footer fx fx-center">
                        <el-button type="primary" @click="subAdd()">确认添加</el-button>
                    </span>
                </el-dialog>
            </template>
        </div>
        <ResourceDrawer :showBox="showResources" @play="play" @close="showResources=false" label="资源列表"
            :resources="currentResources"></ResourceDrawer>
        <VideoDrawer v-if="showVideo" @close="showVideo=false" :url="currentVideo"></VideoDrawer>

        <TaskEdit v-if="showTaskEdit" @submit="loadTasks" @close="showTaskEdit=false" :item="currentTask"></TaskEdit>

        <LessonEditDrawer v-if="showLessonEdit" @submit="loadLesson" @close="showLessonEdit=false"
            :item="currentLesson"></LessonEditDrawer>
    </div>
</template>

<style scoped>
    .tip {
        padding: 0 6px 0 12px;
    }

    .item_block {
        background: white;
        padding: 18px 50px;
        border-radius: 6px;
        margin-bottom: 10px;
    }

    .info_row>*:not(:first-child) {
        margin-left: 50px;
    }

    .coverimg {
        width: 160px;
    }

    .lesson_name {
        font-size: 16px;
        font-weight: bold;
        color: var(--dark);
    }

    .lesson_resource i.iconfont,
    .task_info i.iconfont {
        vertical-align: text-bottom;
    }

    .task_item {
        height: 50px;
        border-bottom: 1px solid var(--border);
    }

    .mask {
        position: relative;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ffffff;
        opacity: 0.5;
        /* 半透明遮罩层 */
        pointer-events: none;
        /* 鼠标事件不被遮罩层捕获，直接传递到底层 */
        z-index: 10;

    }

    .watermark {
        position: absolute;
        /* top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(-45deg); */
        /* 将文字旋转45度 */
        color: rgba(59, 59, 59, 0.7);
        /* 文字颜色 */
        font-size: 1em;
        /* 文字大小 */
        font-style: italic;
        /* 斜体 */
        opacity: 0.9;
        /* 文字半透明 */
        pointer-events: none;
        /* 不捕获鼠标事件 */
    }
</style>
<style>

</style>

<script>
    import ResourceDrawer from '@/components/ResourceDrawer';
    import VideoDrawer from '@/components/VideoDrawer';
    import TaskEdit from "../TaskEdit";
    import LessonEditDrawer from "../LessonEditDrawer";
    export default {
        components: {
            ResourceDrawer,
            VideoDrawer,
            TaskEdit,
            LessonEditDrawer
        },
        props: [
            "attr"
        ],
        data() {
            return {

                loading: false,
                showResources: false,
                currentResources: [],

                showVideo: false,
                currentVideo: null,

                showTaskEdit: false,
                currentTask: {},

                showEdit: false,
                showLessonEdit: false,
                currentLesson: {},

                lessonSystem: this.attr.lessonSystem,

                lessons: [],

                taskData: [],
                taskForm: {
                    keywords: "",
                    knowledgeIds: [],
                    checkType: true,
                    type: 0,
                    relevance: false
                },
                questionData: [],
                form1: {
                    keywords: "",
                },
                trainData: [],
                trainModuleTypes: [],
                form2: {
                    keywords: "",
                    type: 1
                },
                choosedList: [],
                dialogTableVisible: false,
                options: [],
                currentLessonId: 0,
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                activeName: 'task',
                types: [],
                trainCategorys: [],
                trainTags: [],
                lessonTypes: [],
            }

        },

        watch: {
            "taskForm": {
                handler: function(newValue) {
                    this.pager.currentPage = 1;

                    if (this.taskForm.checkType) {
                        this.loadTaskData()
                    } else {
                        this.loadSchoolTaskData();
                    }
                    //this.loadTaskData();
                },
                deep: true
            },
            "form1": {
                handler: function(newValue) {
                    this.pager.currentPage = 1;
                    this.loadQuestionData();
                },
                deep: true
            },
            "form2": {
                handler: function(newValue) {
                    this.pager.currentPage = 1;
                    this.loadTrainModuleData();
                },
                deep: true
            },
            "activeName": {
                handler: function(newValue) {
                    this.pager = {
                        pageSize: 12,
                        dataTotal: 0,
                        currentPage: 1
                    };
                    if (this.activeName == 'task') {
                        this.loadTaskData();
                    }
                    if (this.activeName == 'question') {
                        this.loadTypes();
                        this.loadTrainCategory();
                        this.loadQuestionData();
                        this.loadLessonTypes();
                    }
                    if (this.activeName == 'train') {
                        this.loadTrainModuleTypes();
                        this.loadTrainModuleData();
                    }
                },
                deep: true
            },
        },

        methods: {


            pageChange(page) {
                this.pager.currentPage = page;
                if (this.activeName == 'task') {
                    if (this.taskForm.checkType) {
                        this.loadTaskData()
                    } else {
                        this.loadSchoolTaskData();
                    }
                }
                if (this.activeName == 'question') {
                    // this.loadTypes();
                    // this.loadTrainCategory();
                    this.loadQuestionData();
                    // this.loadLessonTypes();
                }
                if (this.activeName == 'train') {
                    // this.loadTrainModuleTypes();
                    this.loadTrainModuleData();
                }
                // console.log(this.taskForm);

            },
            handleClick(tab, event) {
                this.toActiveName(tab.name);
            },
            //加载单节课
            loadLesson(lesson) {
                lesson.videos = lesson.resources.filter(r => r.category == 1);
                lesson.plans = lesson.resources.filter(r => r.category == 2);
                lesson.ppts = lesson.resources.filter(r => r.category == 3);
                lesson.codes = lesson.resources.filter(r => r.category == 4);
                lesson.tasks = [];
                let index = -1;

                this.lessons.forEach((item, i) => {
                    if (item.id == lesson.id) {
                        index = i;
                        lesson.tasks = item.tasks;
                        return;
                    }
                })
                if (index == -1) {
                    this.lessons.push(lesson);
                } else {
                    this.$set(this.lessons, index, lesson);
                }
                this.showLessonEdit = false;
            },
            //加载所有课
            loadLessons() {
                this.loading = true;
                // console.log(this.lessonSystem)
                // var id =  this.lessonSystem.schoolSystemId!=null?this.lessonSystem.schoolSystemId:this.lessonSystem.id;
                this.$ajaxGet("/lesson/listBySystem/" + this.lessonSystem.id, (data) => {
                    let lessons = data.result;
                    lessons.forEach(item => {
                        item.videos = item.resources.filter(r => r.category == 1);
                        item.plans = item.resources.filter(r => r.category == 2);
                        item.ppts = item.resources.filter(r => r.category == 3);
                        item.codes = item.resources.filter(r => r.category == 4);
                        item.tasks = null;
                    })
                    this.lessons = lessons;

                    if (lessons.length == 0) {
                        // setTimeout(()=>{
                        this.loading = false;
                        // },1000);
                        //this.loading = false;
                    } else {
                        this.loadTasks(lessons.map(item => item.id));
                        // this.loading = false;
                    }

                })
            },
            loadTasks(lessonIds) {
                this.loading = true;
                var url = "/lessonTask/listByLessons";
                this.$ajaxPost(url, {
                    lessonIds: lessonIds
                }, (data) => {
                    data.result.forEach(item => {
                        item.videos = item.resources ? item.resources.filter(i => i.category == 1) : [],
                            item.codes = item.resources ? item.resources.filter(i => i.category == 3) :
                            [],
                            item.tutorials = item.resources ? item.resources.filter(i => i.category ==
                                4) : [],
                            item.attachments = item.resources ? item.resources.filter(i => i.category ==
                                2) : []
                    })
                    this.lessons.forEach(item => {
                        if (lessonIds.some(id => id == item.id)) {
                            item.tasks = data.result.filter(task => task.lessonId == item.id);
                        }
                    })
                    //this.loading = false;
                    this.showTaskEdit = false;
                    setTimeout(() => {
                        //this.loading = false;
                        this.showTaskEdit = false;
                    }, 1000);
                    this.loading = false;
                })
            },
            editTask(item, lessonId) {
                this.currentTask = {
                    ...item,
                    type: this.lessonSystem.type,
                    lessonId: lessonId
                };
                this.showTaskEdit = true;
            },
            delTask(task, lesson) {
                this.$ajaxGet("/lessonTaskLink/del/" + task.lessonTaskLinkId, (data) => {
                    lesson.tasks = lesson.tasks.filter(item => item != task);
                })
            },

            editLesson(item) {
                this.currentLesson = {
                    ...item,
                    type: this.lessonSystem.type,
                    lessonSystemId: this.lessonSystem.id
                };
                this.showLessonEdit = true;
            },

            delLesson(lesson) {
                this.$ajaxGet("/lessonSystemLink/del/" + lesson.lessonSystemLinkId, (data) => {
                    this.lessons = this.lessons.filter(item => item != lesson);
                })
            },


            setShowResources(resources) {
                this.currentResources = resources;
                this.showResources = true;
            },
            play(url) {
                this.currentVideo = url;
                this.showVideo = true;
            },
            viewCode(lessonType, id) {
                this.$goEditCode(lessonType, `mode=caseview&id=${id}`);
            },
            openTask(lessonId) {
                this.currentLessonId = lessonId;
                this.taskForm.keywords = "";
                this.dialogTableVisible = true;
                this.taskForm.checkType = true; //添加任务 默认平台
                this.taskForm.type = this.lessonSystem.type;
                //this.loadTaskData();
            },
            loadTaskData() {
                if (this.dialogTableVisible == false) {
                    return;
                }
                this.loadFuncs();
                this.$ajaxPost("/lessonTask/listByPlatFormId", {
                    form: this.taskForm,
                    pager: {
                        ...this.pager,
                        dataTotal: 0
                    }
                }, (data) => {
                    let {
                        offset,
                        ...pager
                    } = data.pager;
                    this.pager = pager;
                    let items = data.result;
                    items.forEach(item => {
                        item.videos = item.resources.filter(r => r.category == 1);
                        item.attachments = item.resources.filter(r => r.category == 2);
                        item.codes = item.resources.filter(r => r.category == 3);
                        item.tutorials = item.resources.filter(r => r.category == 4);
                    })
                    this.taskData = items;
                    this.activeName = 'task';
                })
            },
            loadSchoolTaskData() {
                if (this.dialogTableVisible == false) {
                    return;
                }
                this.taskForm.type = this.lessonSystem.type;
                this.loadFuncs();
                this.taskForm.lessonId = this.currentLessonId;
                this.$ajaxPost("/lessonTask/listByNotTaskId", {
                    form: this.taskForm,
                    pager: {
                        ...this.pager,
                        dataTotal: 0
                    }
                }, (data) => {
                    let {
                        offset,
                        ...pager
                    } = data.pager;
                    this.pager = pager;
                    let items = data.result;
                    items.forEach(item => {
                        item.videos = item.resources.filter(r => r.category == 1);
                        item.attachments = item.resources.filter(r => r.category == 2);
                        item.codes = item.resources.filter(r => r.category == 3);
                        item.tutorials = item.resources.filter(r => r.category == 4);
                    })
                    this.taskData = items;
                })
            },
            handleChoose(val) {
                this.choosedList = val;
                // console.log(this.choosedList);
            },
            subAdd() {
                let modules = [];
                if (this.activeName == 'task') {
                    modules = this.choosedList.map(item => {
                        return {
                            useType: 1,
                            id: item.id,
                            title: item.title,
                            type: item.type,
                            knowledgeIds: item.knowledgeIds,
                            state: 3,
                            resources: item.resources,
                        }
                    })
                    // console.log(modules);
                } else if (this.activeName == 'question') {
                    modules = this.choosedList.map(item => {
                        return {
                            linkId: item.id,
                            type: item.optType,
                            title: item.questionFormHtml1.substr(0, 90) + (item.questionFormHtml1.length > 90 ? '...' : ''),
                            // tags:item.tags,
                            useType: 2,
                            knowledgeIds: item.knowledgeIds,
                        }
                    })
                    // console.log(modules);

                } else if (this.activeName == 'train') {
                    modules = this.choosedList.map(item => {
                        return {
                            linkId: item.id,
                            type: item.optType,
                            //title: item.title,
                            useType: 3,
                            knowledgeIds: item.knowledgeIds,
                        }
                    })
                }
                this.$ajaxPost("/lessonTask/addLessonTasksByBatch", {
                    list: modules,
                    lessonId: this.currentLessonId,
                    checkType: (this.activeName == 'train' || this.activeName == 'question') ? true : this
                        .taskForm.checkType
                }, (data) => {
                    this.$showSuccess("添加成功");
                    this.loadTasks([this.currentLessonId]);
                    this.dialogTableVisible = false;
                    this.$emit("close");
                })
            },
            loadLessonTypes() {
                this.$ajaxGet("/common/lessonTypeByExamQuestion", (data) => {
                    this.lessonTypes = data.result;
                })
            },
            handleChange(value) {
                // console.log(value);
            },
            changeOptions() {
                this.taskData = [];
                this.pager = {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                };
                if (this.taskForm.checkType) {
                    this.loadTaskData()
                } else {
                    this.loadSchoolTaskData();
                }
            },
            loadFuncs() {
                this.$ajaxPost("/knowledge/knowledgeByTask", {
                    form: this.taskForm
                }, (data) => { //knowledgeTree
                    this.options = data.result;
                })
            },
            loadTrainCategory() {
                let url = this.checkType == true ? "/trainCategory/listOption/1" : "/trainCategory/listOptionByAll/1";
                this.$ajaxGet(url, (data) => {
                    this.trainCategorys = data.result;
                })
            },
            loadTrainTag() {
                let url = this.checkType == true ? "/trainCategory/listOption/2" : "/trainCategory/listOptionByAll/2";
                this.$ajaxGet(url, (data) => {
                    this.trainTags = data.result;
                })
            },
            loadTypes() {
                this.$ajaxGet("/trainQuestion/questionTypes", (data) => {
                    this.types = data.result;
                })
            },
            loadTrainModuleTypes() {
                this.$ajaxGet("/common/trainModuleType", (data) => {
                    this.trainModuleTypes = data.result;
                })
            },
            loadQuestionData() {
                //let url = this.checkType == true ? "/trainQuestion/listByPlatform" : "/trainQuestion/list";
                let url = "/trainQuestion/list";
                this.$ajaxPost(url, {
                    form: this.form1,
                    pager: {
                        ...this.pager,
                        dataTotal: 0
                    }
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {
                        offset,
                        ...pager
                    } = data.pager;
                    this.pager = pager;
                    this.questionData = data.result;
                    this.activeName = 'question';
                })
            },
            loadTrainModuleData() {
                //let url = this.checkType == true ? "/trainModule/listByPlatform" : "/trainModule/list";
                let url = "/trainModule/list";
                this.$ajaxPost(url, {
                    form: this.form2,
                    pager: {
                        ...this.pager,
                        dataTotal: 0
                    }
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {
                        offset,
                        ...pager
                    } = data.pager;
                    this.pager = pager;
                    this.trainData = data.result;
                    this.activeName = 'train';
                })
            },
            toActiveName(name) {
                this.pager = {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                };
                if (name == 'task') {
                    this.loadTaskData();
                }
                if (name == 'question') {
                    this.loadTypes();
                    this.loadTrainCategory();
                    this.loadQuestionData();
                    this.loadLessonTypes();
                }
                if (name == 'train') {
                    this.loadTrainModuleTypes();
                    this.loadTrainModuleData();
                }
            },
        },

        mounted() {

            this.loadLessons();

            // this.loadFuncs();
        }

    }
</script>
